import { withInstall } from '@vuesax-plus/utils'
import loading from './src/loading.vue'

export const IconsLoading = withInstall(loading)
export default IconsLoading

export * from './src/loading'
